<template>
  <q-form
    ref="elementDetail"
    :model="element"
    :rules="elementRules"
    labq-width="100px"
  >
    <q-form-item
      label="نوع"
      prop="type"
    >
      <q-input
        v-model="element.type"
        type="text"
        placeholder=""
      />
    </q-form-item>

    <q-form-item
      label=""
      prop="autoGenerate"
    >
      <q-checkbox
        v-model="element.autoGenerate"
        placeholder=""
      >
        <span>تولید شود</span>
      </q-checkbox>
    </q-form-item>

    <q-form-item
      label="برچسب"
      prop="key"
    >
      <q-input
        v-model="element.label"
        type="text"
        placeholder=""
      />
    </q-form-item>

    <q-form-item
      label="خصوصیت"
      prop="property"
    >
      <q-input
        v-model="element.property"
        type="text"
        placeholder=""
      />
    </q-form-item>

    <q-form-item
      label=""
      prop="disabled"
    >
      <q-checkbox
        v-model="element.disabled"
        placeholder=""
      >
        <span>فقط خواندنی</span>
      </q-checkbox>
    </q-form-item>

    <q-form-item
      label="متن کمکی"
      prop="note"
    >
      <q-input
        v-model="element.note"
        type="textarea"
        placeholder=""
      />
    </q-form-item>

    <q-form-item
      label="متن داخلی"
      prop="placeholder"
    >
      <q-input
        v-model="element.placeholder"
        type="text"
        placeholder=""
      />
    </q-form-item>

    <template v-if="element.type === 'input'">
      <q-form-item
        label="نوع متن"
        prop="inputType"
      >
        <q-input
          v-model="element.inputType"
          type="text"
          placeholder=""
        />
      </q-form-item>
    </template>

    <template v-else-if="element.type === 'checkBox'" />

    <template v-else-if="element.type === 'colorPicker'" />

    <template v-else-if="element.type === 'datePicker'">
      - contain time
    </template>

    <template v-else-if="element.type === 'itemSelector'">
      - items
      <q-form-item
        label="نوع انتخاب"
        prop="selectorType"
      >
        <q-input
          v-model="element.selectorType"
          type="text"
          placeholder=""
        />
      </q-form-item>
    </template>

    <template v-else-if="element.type === 'modelSelector'">
      <q-form-item
        label="نوع انتخاب"
        prop="selectorType"
      >
        <q-input
          v-model="element.selectorType"
          type="text"
          placeholder=""
        />
      </q-form-item>
      <q-form-item
        label="سیستم"
        prop="plugin"
      >
        <q-input
          v-model="element.plugin"
          type="text"
          placeholder=""
        />
      </q-form-item>
      <q-form-item
        label="عملیات واکشی"
        prop="fetchDelegate"
      >
        <q-input
          v-model="element.fetchDelegate"
          type="text"
          placeholder=""
        />
      </q-form-item>
      <q-form-item
        label="فیلد نمایشی"
        prop="displayField"
      >
        <q-input
          v-model="element.displayField"
          type="text"
          placeholder=""
        />
      </q-form-item>
      <q-form-item
        label="فیلد مقدار"
        prop="valueField"
      >
        <q-input
          v-model="element.valueField"
          type="text"
          placeholder=""
        />
      </q-form-item>
    </template>

    <template v-else-if="element.type === 'parameterSelector'">
      <q-form-item
        label="نوع انتخاب"
        prop="selectorType"
      >
        <q-input
          v-model="element.selectorType"
          type="text"
          placeholder=""
        />
      </q-form-item>
      <q-form-item
        label=""
        prop="multiple"
      >
        <q-checkbox
          v-model="element.multiple"
          placeholder=""
        >
          <span>چند انتخابی است</span>
        </q-checkbox>
      </q-form-item>
      <q-form-item
        label="نام پارامتر"
        prop="parameterKey"
      >
        <q-input
          v-model="element.parameterKey"
          type="text"
          placeholder=""
        />
      </q-form-item>
    </template>

    <template v-else-if="element.type === 'number'" />

    <template v-else-if="element.type === 'upload'">
      - file types
    </template>

    <template v-else-if="element.type === 'money'">
      - currency
    </template>

    <template v-else-if="element.type === 'percentage'" />

    <template v-else-if="element.type === 'password'" />

    <template v-else-if="element.type === 'monthPicker'" />

    <template v-else-if="element.type === 'label'" />

    <template v-else-if="element.type === 'compositeList'">
      <q-form-item
        label="نام ساختار لیست"
        prop="structureKey"
      >
        <q-input
          v-model="element.structureKey"
          type="text"
          placeholder=""
        />
      </q-form-item>
    </template>

    <template v-else-if="element.type === 'audience'" />

    <template v-else-if="element.type === 'dateRange'">
      - start time
      - end time
    </template>

    <template v-else-if="element.type === 'numberRange'">
      - min
      - max
    </template>

    <template v-else-if="element.type === 'moneyRange'">
      - currency
      - min
      - max
    </template>

    <template v-else-if="element.type === 'compositeDetail'">
      <q-form-item
        label="نام فرم"
        prop="formStructureKey"
      >
        <q-input
          v-model="element.formStructureKey"
          type="text"
          placeholder=""
        />
      </q-form-item>
    </template>
  </q-form>
</template>

<script>

  export default {
    name: 'QElementSetting',
    props: {
      value: {
        required: true
      },
      model: {}
    },
    data() {
      return {
        element: {},
        elementRules: {
          // plugin: [
          //     {required: true, message: '', trigger: 'blur'},
          // ],
        }
      }
    },
    watch: {
      element() {
        this.$emit('input', this.element);
      },
      value() {
        this.element = this.value;
      }
    },
    created() {
      this.element = this.value;
    }
  }
</script>


<style scoped>
</style>
